import React, { useEffect, useState } from 'react';
import axios from 'axios';
import parse from "html-react-parser";
import { variables } from './Variables.js';
import TrendingList_Ar from './TrendingList_Ar.js';
import TrendingList_Ar2 from './TrendingList_Ar2.js';
export default function TrendingNewsCoins_Ar() {
  const jsonUrl = variables.basename_url + 'updates/index/Coinsinsight_HomeAr_TrendingNews.json';
  const [isLoading, setNisLoading] = useState(false);
  async function refda() {
    setNisLoading(true);
    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    Get_Data();
  }
  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data() {
    JsonArray.splice(0);  //to clear All data in your page
    setNisLoading(true);
    setNisLoading(true);
    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        const newArray = [];
        for (let i = 3; i <= 10 && i < response.data.length; i++) {
          newArray.push({
            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split('T')[0],
            news_imagename: response.data[i].image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),
            Category: response.data[i].Category,
          });
        }
        setJsonArray(newArray); 
      })
  }
  useEffect(() => {
    setNisLoading(true);
    refda();
  }, [])
  return (
    <>
      <div className="section-title mb-4">
        <h3 className="title">اخر الأخبار</h3>
      </div>

      <div className="row">
        {JsonArray.map(da =>
          <div key={da.news_title} className="col-lg-6 col-md-6 col-sm-12 mb-4">
            <div className="trending-news-item">
              <div className="trending-news-thumb">
                <a href={da.link}>
                  <img style={{ maxWidth: '100%', height: '224px', objectFit: 'cover' }} src={da.news_imagename} alt="trending" />
                </a>
              </div>
              <div className="trending-news-content">
                <div className="post-meta">
                  <div className="meta-categories">
                    <a>{da.Category}</a>
                  </div>
                  <div className="meta-date">
                    <span>{da.news_date}</span>
                  </div>
                </div>
                <h3 className="title Arabic-text">
                  <a href={da.link}>{da.news_title}</a>
                </h3>
                <p className="text Arabic-text">{parse(da.Description)}</p>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row mt-4">
        <div className="col-lg-6 col-md-6">
          <div className="trending-news-post-items">
            <TrendingList_Ar />
          </div>
        </div>
        <div className="col-lg-6 col-md-6">
          <div className="trending-news-post-items">
            <TrendingList_Ar2 />
          </div>
        </div>
      </div>
    </>
  );
}



